import { useAppState } from '../hooks/useAppState'
import { usePollReportStatus } from '../hooks/usePollReportStatus'
import { Score } from './Score'

export function Report() {
  const setStatus = useAppState((s) => s.setStatus)
  const query = usePollReportStatus()
  const score = query.data?.data.overallQualityScore ?? 0
  const areaToImprove = query.data?.data.areaToImprove ?? 'Copy'
  return (
    <div className='report'>
      <div>
        <h3>Your Listing Quality Report is Ready</h3>
        <p className='medium'>
          The report’s on its way to your inbox, at the email you provided.
        </p>
      </div>
      <Score value={score} />
      <div className='report-details'>
        <p className='subtitle' style={{ marginBottom: 4 }}>
          Your overall listing quality is {score} out of 100
        </p>
        <p className='small' style={{ marginBottom: 4 }}>
          The listing’s {areaToImprove} stands out as the most impactful
          improvement.
        </p>
        <p className='small'>More details are provided in the full report.</p>
      </div>
      <div style={{ marginTop: 24, width: '100%' }}>
        <button className='outline' onClick={() => setStatus('intake')}>
          Restart
        </button>
      </div>
    </div>
  )
}
